import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from 'react-toastify';

export const GetDemoAnalyticsWT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getDemoAnalyticsWT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_DEMO_CERTIFY_ANALYTICS_WT, payload: data.data });
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
